import { ABTestsContent } from "@/components/ab-tests";

export default function ABTests() {
  return (
    <ABTestsContent />
  );
}
